import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from '../login/login.component';
import { DirettaPortaleComponent } from '../diretta-portale/diretta-portale.component';
import { UserService } from './services/user.service';

const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent }, 
  { path: 'diretta-portale', loadChildren: 'app/diretta-portale/diretta-portale.module#DirettaPortaleModule' }, 
  { path: 'index', loadChildren: 'app/core/masterComponent/pagemaster.module#PageMasterModule', canActivate: [UserService] },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRouting { }


// WEBPACK FOOTER //
// ./src/app/core/app.routing.ts